import React from "react";
import Hero from "../components/Hero";
import Carousel from "../components/Carousel";
import Content from "../components/Content";
import SocialFollow from "../SocialFollow";
import { Icon, InlineIcon } from '@iconify/react';
import whatsappIcon from '@iconify/icons-mdi/whatsapp';

function HomePage(props){

    return(
      <div>
        <Hero title={props.title} subtitle={props.subtitle} text={props.text} />
        <h4>Click On Image To For More Info</h4>
        
        <Carousel />
        <Content>
        <SocialFollow />  <ul>tafadzwamunyuki@gmail.com</ul>              
           <Icon icon={whatsappIcon} /> +263775375088
        </Content>
    </div>
    )
  }

export default HomePage;